/** The twelve question kinds dental paperwork actually needs. Deliberately not a general
 *  form product: every addition here is a new field component and a new PDF renderer case. */
export type QuestionKind =
  | `shortText`
  | `longText`
  | `date`
  | `phone`
  | `email`
  | `address`
  | `singleSelect`
  | `multiSelect`
  | `yesNo`
  | `signature`
  | `initials`
  | `staticText`

export type QuestionOption = { id: string; label: string }

/** One level of conditional display. No expression language, by design. */
export type ShowWhen = { questionId: string; equals: string }

export type FormQuestion = {
  /** Minted once at creation and never derived from the label. Mappings bind to this,
   *  so editing the wording of a question can never orphan its mapping. */
  id: string
  kind: QuestionKind
  label: string
  helpText?: string
  required: boolean
  options?: QuestionOption[]
  showWhen?: ShowWhen
  /** The Contact field this answer lands on, or undefined for answer-only. */
  mappingTarget?: string
}

export type FormCategory = `registration` | `medicalHistory` | `consent` | `financialPolicy` | `custom`

export type FormDefinition = {
  id: string
  name: string
  description?: string
  category: FormCategory
  version: number
  questions: FormQuestion[]
}

export type AnswerValue = string | string[]

/** Working shape while the patient is filling the form. Keyed by question id. */
export type AnswerMap = Record<string, AnswerValue>

/** Wire shape. An array, so a nine-question form can only ever produce nine entries. */
export type Answer = { questionId: string; value: AnswerValue }

/** Question kinds that hold no answer and can never be required. */
export const NON_ANSWERABLE_KINDS: QuestionKind[] = [`staticText`]
